export default "/images/vendor/flag-icons/flags/4x3/ar.svg?6a3e52fbf8d109a5fd43db358f6d1a1b";